const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)

import main from '@/modules/productsStorage/components/storageAndGoods/main'
import report from '@/modules/productsStorage/components/storageAndGoods/tabs/report.vue'
import goods from '@/modules/productsStorage/components/storageAndGoods/tabs/goods.vue'
import productsRoutes from '@/modules/products/routes'
import history from '@/modules/productsStorage/components/storageAndGoods/tabs/history'
import moveGoods from '@/modules/productsStorage/components/storageAndGoods/moveGoods'

export default [
  {
    path: '/move-hookah',
    name: 'MoveHookah',
    component: {
      template: '<div class="content-wrapper"><router-view></router-view></div>'
    },
    meta: {
      title: 'Перемещение табаков',
      menuKey: 'MoveHookah'
    },
    redirect: '/move-hookah',
    children: [
      {
        path: '/',
        component: moveGoods,
        meta: {
          title: 'Перемещение табаков',
          menuKey: 'MoveHookah'
        }
      }
    ]
  },
  {
    path: '/products-storage',
    component: _import('productsStorage/components/wrapper'),
    meta: {
      title: 'Склад и товары',
      showInMenu: true,
      menuKey: 'ProductsStorage',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']

    },
    redirect: '/products-storage/storage-and-goods',
    children: [
      ...productsRoutes,
      {
        path: 'storage-and-goods',
        name: 'StorageGoods',
        component: {
          template: '<div class="content-wrapper"><router-view></router-view></div>'
        },
        meta: {
          title: 'Склады и товары',
          menuKey: 'ProductsStorage',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        },
        redirect: '/products-storage/storage-and-goods/report',
        children: [
          {
            path: '',
            name: 'StorageGoods.main',
            component: main,
            meta: {
              title: 'Склады и товары',
              menuKey: 'ProductsStorage',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            },
          },
          {
            path: 'move',
            name: 'StorageGoods.move',
            component: moveGoods,
            meta: {
              title: 'Перемещение товаров',
              menuKey: 'ProductsStorage',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            },
          },
          {
            path: 'receipt',
            name: 'StorageGoods.receipt',
            component: _import('productsStorage/components/storageAndGoods/receiptGoods'),
            meta: {
              title: 'Поступление товаров',
              menuKey: 'ProductsStorage',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            },
          },
        ]
      },
      {
        path: 'places',
        component: {
          template: '<div class="content-wrapper"><router-view></router-view></div>'
        },
        name: 'Places',
        meta: {
          title: 'Места хранения',
          menuKey: 'ProductsStorage',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        },
        children: [
          {
            path: '',
            component: _import('productsStorage/components/places/list'),
            name: 'Places.list',
            meta: {
              menuKey: 'ProductsStorage',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            }
          },
          {
            path: 'create',
            component: _import('productsStorage/components/places/create'),
            name: 'Places.create',
            meta: {
              menuKey: 'ProductsStorage',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            }
          },
          {
            path: 'edit/:id',
            component: _import('productsStorage/components/places/edit'),
            name: 'Places.edit',
            meta: {
              menuKey: 'ProductsStorage',
              roles: ['ROLE_ADMIN', 'ROLE_WAITER']
            }
          }
        ]
      },
      //
      // {
      //   path: 'storage_and_goods/receipt',
      //   name: 'storage_and_goods_receipt',
      //   component: {
      //     template: '<router-view></router-view>'
      //   },
      //   children: [
      //     {
      //       path: '',
      //       component: _import('productsStorage/containers/storage_and_goods/receiptGoods'),
      //       name: 'receipt_goods'
      //     }
      //   ]
      // },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/productsStorage/routes.js